/*
 * Редактирование кейсета - https://tanker.yandex-team.ru/project/adv-frontend-filters/keyset/components%2FquickFilters%2FTreeQuickFilter%2FTreeQuickFilter.i18n.ts
 * Документация локализации - https://a.yandex-team.ru/arcadia/adv/frontend/docs/monorepo/i18n.md
 */
import { createI18n, createI18nRaw, createKeyset } from '@adv-frontend/l10n/src/i18n';
const keyset = createKeyset({
    'Значение фильтра не найдено': {
        ru: 'Значение фильтра не\u00A0найдено',
        en: 'Filter value not found',
        'en-IE': 'The filter value was not found',
        tr: 'Filtre değeri bulunamadı',
        'zh-Hans': '未找到筛选器值',
    },
    Поиск: {
        ru: 'Поиск',
        en: 'Search',
        'en-IE': 'Search',
        tr: 'Arama',
        'zh-Hans': '搜索',
    },
    'Попробовать снова': {
        ru: 'Попробовать снова',
        en: 'Try again',
        'en-IE': 'Try again',
        tr: 'Tekrar dene',
        'zh-Hans': '再试一次',
    },
    Сбросить: {
        ru: 'Сбросить',
        en: 'Reset',
        'en-IE': 'Throw off',
        tr: 'Sıfırla',
        'zh-Hans': '重置',
    },
    'Что-то пошло не так': {
        ru: 'Что-то пошло не\u00A0так',
        en: 'Something went wrong',
        'en-IE': 'Something went wrong.',
        tr: 'Hata oluştu',
        'zh-Hans': '发生错误',
    },
});
export const i18n = createI18n(keyset);
export const i18nRaw = createI18nRaw(keyset);
